module.exports = __webpack_public_path__ + "static/media/Mobility0551d2dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Mobility.svg
// module id = 1305
// module chunks = 0